export function ToProductList(_productList: any) {
  const productList = [];
  if (_productList !== null) {
    for (let productCount = 0; productCount < _productList.length; productCount++) {
      const _product = _productList[productCount];
      const product = {
        id: _product.id,
        name: _product.name,
        typeId: _product.typeId,
        unitId: _product.unitId,
        unitNameEng: _product.unitNameEng,
        unitNameTh: _product.unitNameTh,
        description: _product.description,
        code: _product.code,
        purchaseAccountId: _product.purchaseAccountId,
        purchaseVatType: _product.purchaseVatType,
        purchasePrice: _product.purchasePrice,
        sellAccountId: _product.sellAccountId,
        sellVatType: _product.sellVatType,
        sellPrice: _product.sellPrice,
      };
      productList.push(product);
    }
  }
  return productList;
}
